export default __webpack_public_path__ + "static/media/ic-social-tw.7279cc9c.svg";